import { customObjectProvisioningStateMapKey } from "components/ProvisioningStateDot/constants";

export const actions = {
    STORE_CUSTOM_OBJECT_PROVISIONING_STATE: "STORE_CUSTOM_OBJECT_PROVISIONING_STATE",
};

export const initialState = {
    [customObjectProvisioningStateMapKey]: {},
};

export default (state = initialState, { type, data }) => {
    switch (type) {
        case actions.STORE_CUSTOM_OBJECT_PROVISIONING_STATE: {
            return {
                ...state,
                [customObjectProvisioningStateMapKey]: {
                    ...state[customObjectProvisioningStateMapKey],
                    ...data,
                },
            };
        }

        default:
            return state;
    }
};
